import React, { useState, useEffect } from 'react';
import axios from 'axios';
import tradeCheck from '../../assets/trade_check.png';
import '../../css/ServiceCompanyLanding.css';

function ServiceCompanyLanding() {
    const [trades, setTrades] = useState([]);
    const [selectedTrades, setSelectedTrades] = useState([]);

    useEffect(() => {
        axios.get('/api/trades')
            .then(response => setTrades(response.data))
            .catch(error => console.error('Error fetching trades:', error));
    }, []);

    const getImagePath = (filename) => {
        try {
            return require(`../../assets/trades/${filename}`);
        } catch (error) {
            console.error('Error loading image:', error);
            return null;
        }
    };

    const toggleSelection = (index) => {
        setSelectedTrades((prevSelectedTrades) => {
            if (prevSelectedTrades.includes(index)) {
                return prevSelectedTrades.filter(i => i !== index);
            } else if (selectedTrades.length < 4) {
                return [...prevSelectedTrades, index];
            } else {
                return prevSelectedTrades;
            }
        });
    };

    return (
        <div className="service-company-landing-container">
            <div className="service-company-landing-first-container">
                <div className="service-company-landing-first-wrap">
                    <div className="service-company-landing-first-title">
                        Realtor Developed Service Directory for Realtors
                    </div>
                    <div className="service-company-landing-first-body">
                        Hi! I'm John, a Realtor and a real estate investor, and I am proud to launch the only service
                        directory designed specifically for Realtors. It's a unique opportunity for service companies
                        to connect directly with real estate professionals seeking quality providers for their clients.
                    </div>
                    <div className="service-company-landing-first-button">
                        <a href={"/service-company-registration?trades=" + selectedTrades.join(',')}>
                            <div className="blue-button">JOIN US NOW</div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="service-company-landing-second-container">
                <div className="service-company-landing-second-wrap">
                    <div className="service-company-landing-second-title">
                        Select Your Trades
                    </div>
                    <div className='service-company-landing-second-body-wrap'>
                        <div className="service-company-landing-second-body">
                            {trades.length === 0 ? (
                                <p>Loading trades...</p>
                            ) : (
                                trades.map((trade) => (
                                    <div
                                        key={trade.id}
                                        className={'service-company-landing-trade-wrapper'}
                                        onClick={() => toggleSelection(trade.id)}
                                    >
                                        <div className={`service-company-landing-trade-image ${selectedTrades.includes(trade.id) ? 'selected' : ''}`}>
                                            <img src={getImagePath(trade.icon)} alt={trade.name}/>
                                        </div>
                                        {selectedTrades.includes(trade.id) ? (
                                            <div className="service-company-landing-trade-checked">
                                                <img src={tradeCheck} alt={'checked'}/>
                                            </div>
                                        ) : null}
                                        <div className="service-company-landing-trade-name">
                                            {trade.name}
                                        </div>
                                    </div>
                                ))
                            )}
                            <div className="service-company-landing-trade-submit-button-container large">
                                <a href={"/service-company-registration?trades=" + selectedTrades.join(',')}>
                                    <div
                                        className={`service-company-landing-trade-submit-button ${selectedTrades.length > 0 ? 'action' : ''}`}>
                                        JOIN NOW &gt;&gt;
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="service-company-landing-trade-submit-button-container small">
                            <a href={"/service-company-registration?trades=" + selectedTrades.join(',')}>
                                <div
                                    className={`service-company-landing-trade-submit-button ${selectedTrades.length > 0 ? 'action' : ''}`}>
                                    JOIN NOW &gt;&gt;
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="service-company-landing-third-container">
                <div className="service-company-landing-third-wrap">
                    <div className="service-company-landing-third-title">
                    Realtor Customers, Repeat Business!
                    </div>
                    <div className="service-company-landing-third-body">
                        <p>We focus on quality connections - no ads, no lead selling, no review solicitation.</p>

                        <p>Save thousands by avoiding expensive keywords, shared leads, and complicated CRMs. Instead, we’ll showcase your expertise and connections in ways you’ve never imagined.</p>

                        <p>What's the benefit for you? More realtor customers, deeper relationships, and increased referrals. 100% Free Access</p>
                    </div>
                    <div className="service-company-landing-third-button">
                        <a href={"/service-company-registration?trades=" + selectedTrades.join(',')}>
                            <div className="blue-button">JOIN US NOW</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceCompanyLanding;
